<template>
  <div class="bbs">
    <div class="top">
      <div class="imte__bag">Forum</div>
      <div class="imte__min">通讯录</div>
    </div>
    <div class="content">
      <Table
        v-if="data.length > 0"
        border
        :columns="columns"
        :data="data"
        ref="table"
        style="width: 1000px;margin: 0 auto;"
      ></Table>
      <span v-else>当前还没有人发帖</span>
      <Page :total="data.length" />
      <!-- <div style="width: 1000px;margin: 0 auto;">
        <Form
          ref="formValidate"
          :model="formValidate"
          label-position="left"
          :rules="ruleValidate"
          :label-width="100"
        >
          <FormItem label="标题" prop="title">
            <Input v-model="formValidate.title"></Input>
          </FormItem>
          <FormItem label="内容" prop="content">
            <Input
              v-model="formValidate.content"
              type="textarea"
              :autosize="{ minRows: 8, maxRows: 15 }"
              placeholder="在此输入内容..."
            ></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
          </FormItem>
        </Form>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      columns: [
        {
          title: "届别",
          key: "class",
          sortable: true,
          // sortMethod: (a,b)=>{

          // }
        },
        {
          title: "姓名",
          key: "name"
        },
        {
          title: "头衔",
          key: "title"
        },
        {
          title: '联系方式',
          key: 'phone'
        }
      ],
      data: [
        {
          name: "张三",
          title: "博士",
          class: "2016",
          phone: "12312312312"
        },
        {
          name: "李四",
          title: "博士",
          class: "2016",
          phone: "12312312312"
        },
        {
          name: "王五",
          title: "博士",
          class: "2016",
          phone: "12312312312"
        },
        {
          name: "陈二",
          title: "硕士",
          class: "2016",
          phone: "12312312312"
        }
      ],
      formValidate: {
        title: "",
        content: ""
      },
      ruleValidate: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        content: [
          { required: true, message: "内容不能为空", trigger: "blur" },
          {
            type: "string",
            min: 10,
            message: "内容不能少于10字",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {},
  created() {
    this.$emit("changeProduce", "bbs");
  },
  mounted() {},
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$Message.success("发帖成功!");
          this.$refs[name].resetFields();
          this.$refs.table.refresh()

        } else {
          this.$Message.error("发帖失败!");
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.bbs {
  .top {
    width: 100%;
    height: 280px;
    background: url("https://hjg-officialwebsite.oss-cn-shenzhen.aliyuncs.com/user_bg.png")
      center center no-repeat;
    background-size: 100% 100%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    padding-top: 54px;
    padding-left: 240px;
    font-weight: bold;
    color: #fff;
    .imte__bag {
      font-size: 40px;
      margin-bottom: 32px;
    }

    .imte__min {
      font-size: 24px;
    }
    &__large {
      margin-top: 16px;
      font-size: 24px;
      line-height: 1.5em;
    }
    &__small {
      font-size: 14px;
      line-height: 1.5em;
    }
  }
  .content {
    width: 80%;
    // height: 500px;
    margin: 30px auto;

    /deep/ .ivu-page {
      text-align: center;
      margin: 30px 0;
    }
  }
}
</style>
